import { createClient } from "@supabase/supabase-js";
// We will generate these types in the next step
import type { Database } from "../types/supabase";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase environment variables");
}

// Create a single instance of the client
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
